export default __webpack_public_path__ + "static/media/highlight2.58bb3a0e.jpg";